import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import index from '../pages/index/index.vue'
import ceshi from '../pages/ceshi/ceshi.vue'
import policy from '../pages/policy/policy.vue'
import list from '../pages/policy/policy-list.vue'
import view from '../pages/policy/view.vue'
import example from '../pages/example/example.vue'
import examplelist from '../pages/example/example-listt.vue'
import exampleview from '../pages/example/view.vue'
import abouts from '../pages/about/about.vue'
import join from '../pages/join/join.vue'
import verify from '../pages/verify/verify.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/abouts',
      name: 'abouts',
      component: abouts
    },
    {
      path: '/ceshi',
      name: 'ceshi',
      component: ceshi
    },
    {
      path: '/example',
      // name: 'policy',
      component: example,
      children: [
        {
          path: '/',
          name: 'example-listt',
          component: examplelist
        },
        {
          path: '/example/view/:tid',
          name: 'example-view',
          component: exampleview
        }
      ]
    },
    {
      path: '/join',
      name: 'join',
      component: join
    },
    {
      path: '/policy',
      // name: 'policy',
      component: policy,
      children: [
        {
          path: '/',
          name: 'policy-list',
          component: list
        },
        {
          path: '/policy/view/:tid',
          name: 'view',
          component: view
        }
      ]
    },
    {
      path: '/verify',
      name: 'verify',
      component: verify
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js